export default "<app-choose-us [lists]=\"List\"></app-choose-us>\n"